<div class="modal-header">
  <h4 class="modal-title">{{ 'settings.facebookpage_selector.select_the_pages_you_want_to' | t:'Select the pages you want to Connect' }}</h4>
  <button type="button" class="btn btn-clear kt-padding-0 kt-svg-icon kt-svg-icon-solid" [attr.aria-label]="'common.close' | t:'Close'"
    (click)="close()" [inlineSVG]="'Navigation/Close.svg'">

  </button>
</div>
<div class="modal-body">
  <form [formGroup]="facebookPagesList">
    <div formArrayName="pageslist">
      @for (page of pages; track page; let i = $index) {
        <div class="page">
          <label class="kt-checkbox kt-checkbox--solid">
            <input type="checkbox" [formControlName]="i" />
            <img [src]="page.picture" />
            {{page.name}}
            <span></span>
          </label>
        </div>
      }
    </div>
  </form>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="linkPages()">{{ 'settings.facebookpage_selector.link_pages' | t:'Link Pages' }}</button>
</div>